import { useAppDispatch } from '@/shared/hooks';

import { accessModel } from '@/entities/access';
import { patientModel } from '@/entities/patient';

export const useRevokeSharedPatient = () => {
  const dispatch = useAppDispatch();

  return async ({
    patientID,
    sharedPatientDoctorID,
  }: {
    patientID: string;
    sharedPatientDoctorID: string;
  }) => {
    const { Sharing, Patient } = await dispatch(
      accessModel.thunks.revokeSharing({
        PatientID: patientID,
        UserID: sharedPatientDoctorID,
      }),
    ).unwrap();

    if (Sharing?.ID) {
      dispatch(accessModel.sharingActions.removeOne(Sharing.ID));
    }

    if (Patient) {
      dispatch(patientModel.actions.setNewestOne(Patient));
    }
  };
};
